// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#delete_account_notification{background-color:#E6493B;color:white;min-height:25px;line-height:25px;font-size:16px}#delete_account_notification a{color:white;font-weight:bold}\n", ""]);
// Exports
module.exports = exports;
